import { closeModal } from "./closeModal";

export const handleBackdropClick = (event, modal) => {
  if (event.target === modal) {
    closeModal(modal);
  }
};
